import { useBusinessModelSelector } from "@redux/reducers/deal";
import { useDeliveryMethods } from "@hooks/useDeliveryMethods";
import { DELIVERY_METHOD } from "@shared/constants";

export const useIsHomeDeliveryEnabled = () => {
  const businessModel = useBusinessModelSelector();
  const deliveryMethods = useDeliveryMethods(businessModel) || [];

  if (!Array.isArray(deliveryMethods)) {
    return false;
  }

  return deliveryMethods.some(
    deliveryMethod =>
      deliveryMethod.type === DELIVERY_METHOD.HOME && deliveryMethod.enabled
  );
};
